import { render, staticRenderFns } from "./AcceptForm.vue?vue&type=template&id=dcaf1a64&scoped=true&"
import script from "./AcceptForm.vue?vue&type=script&lang=js&"
export * from "./AcceptForm.vue?vue&type=script&lang=js&"
import style0 from "./AcceptForm.vue?vue&type=style&index=0&id=dcaf1a64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcaf1a64",
  null
  
)

export default component.exports